import axios from "axios";

const API_URL = "/authservice-api/auth/login"

axios.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem("token") || "";
        config.headers["Authorization"] = `${token}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const register = (username, email, password) => {
    return axios.post(`${API_URL}`, {
        username,
        email,
        password,
    });
};

    const login = (code, isApiUser, username, password) => {
    return axios
        .get(`${API_URL}`, {

            params: {code: code, isApiUser: isApiUser},
            headers: {'username': username, 'password': password},

        })
        .then(response => {
            if (response.data && response.data.token) {
                localStorage.setItem("token", "Bearer " + (response.data.token));
            }
            return response.data;
        });
};

const logout = () => {
    localStorage.removeItem("token");
};

export default {
    login,
};


/*).catch(error => {
    if (error.response.status === 401) {
        console.log(error.response.status)
        console.log("Kullanıcı Bilgileri Hatalı")
        return error.response.status;
    }

}*/
